import { render, staticRenderFns } from "./LayerAddingPermissionsListItem.vue?vue&type=template&id=4971eb96&scoped=true&"
import script from "./LayerAddingPermissionsListItem.vue?vue&type=script&lang=js&"
export * from "./LayerAddingPermissionsListItem.vue?vue&type=script&lang=js&"
import style0 from "./LayerAddingPermissionsListItem.vue?vue&type=style&index=0&id=4971eb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971eb96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VListItem,VListItemContent,VListItemTitle,VRow,VSpacer})
